import React from 'react';
import { cn } from '@/lib/utils';

export type StatusType = 'pending' | 'approved' | 'rejected' | 'draft' | 'in_progress' | 'completed';

interface StatusBadgeProps {
  status: StatusType;
  children: React.ReactNode;
  className?: string;
}

const statusClasses = {
  pending: 'badge-pending',
  approved: 'badge-approved',
  rejected: 'badge-rejected',
  draft: 'badge-draft',
  in_progress: 'badge-pending',
  completed: 'badge-approved',
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ 
  status, 
  children, 
  className 
}) => {
  return (
    <span className={cn(statusClasses[status], className)}>
      {children}
    </span>
  );
};